import { EventBus } from '@/game/GameComponents/PhaserGame/EventBus';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import { setBitmapColor } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import {
  DEFAULT_CURSOR_PATH,
  HOVER_CURSOR_PATH,
} from '@/game/GameComponents/Utils/GameSpriteAssetsMap';
import ShopTab from '@/game/prefabs/CosmeticShop/ShopTab';
import ShopTab_m from '@/game/prefabs/CosmeticShop/ShopTab_m';

export class ShopTabController {
  constructor(private tab: ShopTab | ShopTab_m) {
    tab.tabBacking.setInteractive({ cursor: `${HOVER_CURSOR_PATH}` });
    tab.tabBacking.on('pointerdown', () => {
      const { tab } = this;
      this.setSelected(!this.isSelected);
      EventBus.emit(GAME_EVENTS.SHOP_TAB_SELECTED, tab);
      this.onUserSelectedTab.forEach((fn) => fn(tab));
      PhaserAudioManager.playSFX(tab.scene, 'submit-click');
    });
    tab.tabBacking.on('pointerover', () => {
      if (this.isSelected) return;
      tab.tabBacking.setTexture(tab.hoverBackingTex);
      PhaserAudioManager.playSFX(tab.scene, 'hover-click');
    });
    tab.tabBacking.on('pointerout', () => {
      if (this.isSelected) return;
      tab.tabBacking.setTexture(tab.defaultBackingTex);
    });
    tab.disabledCover.setInteractive({ cursor: `${DEFAULT_CURSOR_PATH}` });
    this.setNotificationActive(false);
    this.setDisabled(false);
  }

  imageTexture?: string;
  isSelected: boolean = false;
  isEnabled: boolean = true;
  tabData?: { name: string; icon: string; slot: string };
  jointTab?: ShopTab | ShopTab_m;
  onUserSelectedTab: Array<(tab: ShopTab | ShopTab_m) => void> = [];

  setTabData(data: { name: string; icon: string; slot: string }) {
    const { tab } = this;
    this.tabData = data;
    if ('tabTitle' in tab) {
      tab.tabTitle.setText(data.name);
    }

    tab.tabImage.setTexture(data.icon);
    this.imageTexture = data.icon;
  }

  setSelected(isSelected: boolean) {
    const { tab } = this;
    this.isSelected = isSelected;
    tab.tabImage.setTexture(
      isSelected ? `${this.imageTexture}-hover` : `${this.imageTexture}`,
    );
    tab.tabBacking.setTexture(
      isSelected ? tab.selectedBackingTex : tab.defaultBackingTex,
    );
    if ('tabTitle' in tab) {
      setBitmapColor(tab.tabTitle, isSelected ? 0xe6dddc : 0x52333f);
    }
  }

  setNotificationActive(isActive: boolean) {
    this.tab.shopTabNotification.setVisible(isActive);
  }

  setDisabled(isDisabled: boolean) {
    this.tab.disabledCover.setVisible(isDisabled);
    this.isEnabled = !isDisabled;
  }

  joinToTab(tab: ShopTab | ShopTab_m) {
    this.jointTab = tab;
    tab.controller.jointTab = this.tab;
  }
}
